import React, { useState, useEffect, useContext } from 'react';
import {format} from "date-fns";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import * as net from "../../../lib/net";

import Dd_Sel from "../../../lib/ui/dd_sel";
import Td_Sel from "../../../lib/ui/td_sel";
import Dt_Cal from "../../../lib/ui/dt_cal";
import Wnd_Error from "../../../lib/ui/wnd_error";
import Wnd_Ok from "../../../lib/ui/wnd_ok";
import Wnd_Info from "../../../lib/ui/wnd_info";
import Wnd_Confirm from "../../../lib/ui/wnd_confirm";
import * as utils from "../../../assets/utils";

class Pres_Full extends React.Component {
  constructor(props, context) {
    super(props);

    this.dt_fd = React.createRef();
    this.dt_td = React.createRef();

    this.selitems = [
        {fkn: 'bevaka', text: 'BEVAKA'},
        {fkn: 'bokbild', text: 'BOKNINGSBILD'},
        {fkn: 'confirm', text: 'BEKRÄFTA'},
        {fkn: 'cancel', text: 'AVBOKA'}
    ];

    this.store = props.store;
    this.pms = props.store.pms;

    this.state = {};
    this.state.ynq = [];
    //this.state.vga = [];
    this.state.rta = [];
    this.state.bra = [];

    this.state.dta = [];
    this.state.paa = [];
    this.state.pra = [];

    this.state.tot = {};

    this.state.krubba = 0;
    this.state.ix = 0;
    this.state.boknr = "";
    this.state.datum = "";

    this.state.today = new Date();
    var dts = format(this.state.today, "yyyy-MM-dd");
    this.state.fdat = dts;
    this.state.tdat = dts;

    //if(this.pos.base) {
    //    this.state.fdat = this.pos.base.fdat;
    //    this.state.tdat = this.pos.base.tdat;
    //}

      this.state.msg = {};
      this.state.wnds = {};
    this.state.rvo = {};
    if(props.wnds) {
        //if(props.wnds.boknr) this.state.boknr = props.wnds.boknr;
    }
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      this.reg_all();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
  val_pris(val) {
      var s = "";
      if(val == 0) s = "0.00";
      if(val) s = val.cdipris();
      return s;
  };

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var rvo = this.state.rvo;
      var na = name.split(".");
      rvo[na[0]][na[1]] = value;
      this.setState({rvo: rvo});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
      if(this.props.close) {
          this.props.close(this.props.ctx);
      }
      else this.props.ctx.setState({ wnds: {} });
	};
  tb_style() {
    var css = {};
    css.height = (window.innerHeight * 0.9) - 205;
    css.overflow = "auto";
    return css;
}
  val_save (name, value) {
        //alert(JSON.stringify(name));
        //alert(JSON.stringify(value));
      var rvo = this.state.rvo;
      var na = name.split(".");
      rvo[na[0]][na[1]] = value;
      this.setState({rvo: rvo});
      //setState({[name]: value});
    }
  dt_fdat(e) {
    //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ fdat: dts });
  }
  dt_tdat(e) {
      //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ tdat: dts });
  }
  oneday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_td.current.updateDt(this.state.fdat);
  }
  addday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateAdd();
    this.dt_td.current.updateAdd();
  }
  subday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_fd.current.updateSub();
    this.dt_td.current.updateSub();
  }
  gst_open(row) {
    //alert(JSON.stringify(row));
    var wnds = {};
    wnds.saldogst = true;
    wnds.boknr = row.boknr;
    wnds.glopnr = row.glopnr;
    this.setState({wnds: wnds});
  }
  
  reg_all() {
    var self = this;

    var msg = { info: true, text: "Hämtar Register ..."};
    self.setState({ msg: msg });

    //var fdatum = format(this.state.fdat, "yyyy-MM-dd");
    //var tdatum = format(this.state.tdat, "yyyy-MM-dd");
    self.setState({ dta: [], paa: [], pra: [], krubba: 0 });

    var prm = {};
    prm.req = "crs.crs_reg.pres_list";
    prm.fdat = this.state.fdat;
    prm.tdat = this.state.tdat;
    //prm.sid = "S0001611";

    //net.sid_req(prm)
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            self.setState({ msg: {} });
            return;
        }
        var pra = ret.rca;
        var tot = ret.tot;
        self.setState({ paa: pra, pra: pra, tot: tot, msg: {} }, function() {
            self.syncTb("fullTable");
        });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }

  reg_na() {
    var self = this;

    var msg = { info: true, text: "Hämtar Register ..."};
    self.setState({ msg: msg });

    //var fdatum = format(this.state.fdat, "yyyy-MM-dd");
    //var tdatum = format(this.state.tdat, "yyyy-MM-dd");
    self.setState({ dta: [], paa: [], pra: [], krubba: 0 });

    var prm = {};
    prm.req = "crs.crs_reg.pres_na";
    prm.fdat = this.state.fdat;
    prm.tdat = this.state.tdat;
    //prm.sid = "S0001611";

    //net.sid_req(prm)
    net.sio_req(prm)
    .then(function(ret){
        alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            self.setState({ msg: {} });
            return;
        }
        var pra = ret.rca;
        var tot = ret.tot;
        self.setState({ paa: pra, pra: pra, tot: tot, msg: {} }, function() {
            self.syncTb("fullTable");
        });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }

  syncTb(tb){
    if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
        tdElements = tbel.getElementsByTagName('td');

        for (let i = 0; i < thElements.length; i++) {
            if(!thElements[i]) continue;
            if(!tdElements[i]) continue;
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
            width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }

    reg_active(){
    }
    reg_closed(){
    }
        
  render() {
    //if(!this.props.show) return "";

    var title = this.props.title;
    if(!title) title = "Bokning";

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_90 flex-col" style={ this.dlg_style() }>
        <div className="mx_h01">
            <div>REGISTER</div>
        </div>

            <div className="divider_orange hide"></div>

            <div className="flex-row">
                 <button className="btn btn-hw-blue w150" onClick={() => this.reg_closed() } aria-label="System" >
                    FÖRBRUKADE
                </button>
                <button className="btn btn-hw-blue w150" onClick={() => this.reg_active() } aria-label="System" >
                    AKTIVA
                </button>
                <div className="flex"></div>
            <div className="flex-row">
                  <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
                  <Dt_Cal dts={ this.state.fdat } rp="1" ref={this.dt_fd} getValue={(e)=> this.dt_fdat(e)} />
                  <div className="dt-btn-01" onClick={() => this.oneday() } >1</div>
                  <Dt_Cal dts={ this.state.tdat } rp="1" ref={this.dt_td} getValue={(e)=> this.dt_tdat(e)} />
                  <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
            </div>
                <div className="flex"></div>
                <button className="btn btn-hw-red w150" onClick={() => this.reg_na() } aria-label="System" >
                    EJ AKTIVERADE
                </button>
                <button className="btn btn-hw-green w150" onClick={() => this.reg_all() } aria-label="System" >
                    AKTIVERADE
                </button>
            </div>

       <div className="mx_content flex">

        <div id="fullTable">
        <table className="table table-bordered table-hover tb " style={{marginBottom: "0px"}}>
            <thead>
            <tr>
            <th onClick={() => this.tb_sort("pres00.p0id") }>Pres Nr</th>
            <th onClick={() => this.tb_sort("pres02.p2cardnr") }>Kort Nr</th>
                <th onClick={() => this.tb_sort("pres00.p0text") }>Text</th>
                <th onClick={() => this.tb_sort("pres00.p0datum") }>Datum</th>
                <th onClick={() => this.tb_sort("pres00.p0expire") }>Giltigt</th>
                <th onClick={() => this.tb_sort("pres00.p0belopp") }>Belopp</th>
                <th onClick={() => this.tb_sort("pres00.p0saldo") }>Att utnyttja</th>
                <th onClick={() => this.tb_sort("pres01.p1issuedby") }>Utställt</th>
                <th onClick={() => this.tb_sort("pres01.p1anm") }>Information</th>
                <th></th>
            </tr>
            </thead>
            </table>
            <div style={ this.tb_style() }>
          <table className="table table-bordered table-hover">
            <tbody>
            { this.state.pra.map((row, key) =>
            <tr key={key} onDoubleClick={() => this.preg_edit(row) }>
                <td className="text-center">{ utils.toNum(row.pres00.p0id) }</td>
                <td className="text-center">{ utils.toNum(row.pres02.p2cardnr) }</td>
                <td>{ row.pres00.p0text }</td>
                <td>{ utils.toDate(row.pres00.p0datum) }</td>
                <td>{ utils.toDate(row.pres00.p0expire) }</td>
                <td>{ utils.toPris(row.pres00.p0belopp) }</td>
                <td>{ utils.toPris(row.pres00.p0saldo) }</td>
                <td>{ row.pres01.p1issuedby }</td>
                <td>{ row.pres01.p1anm }</td>
                <td>
                    <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                </td>
            </tr>
            )}
            </tbody>
        </table>
        
        </div>
        </div>
           <div className="divider_green"></div>
           <div className="flex-row px-5">
               <div className="flex">TOTALER:</div>
               <div className="px-5">ANTAL: { utils.toNum(this.state.tot.antal) }</div>
               <div className="px-5">BELOPP: { utils.toPris(this.state.tot.belopp) }</div>
               <div className="px-5">SALDO: { utils.toPris(this.state.tot.saldo) }</div>
           </div>

            </div>

            <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex-row">
            </div>
        </div>
      </div>
            <Wnd_Error msg={this.state.msg} ctx={this} />
            <Wnd_Ok msg={this.state.msg} ctx={this} />
            <Wnd_Info msg={this.state.msg} ctx={this} />
            <Wnd_Confirm msg={this.state.msg} ctx={this} />

    </div>
	;
	return html;
  };
}

export default Pres_Full;